import React from 'react'

export default function Server() {
  return (
    <div>Server</div>
  )
}
